export default (process.env.NODE_ENV == 'dev') ? 'https://dev.api.doctorplan.com' :
			  ((process.env.NODE_ENV == 'local') ? 'http://localhost:8000' : 'https://api.doctorplan.com')
